import React from "react";
import { useNavigate } from "react-router-dom";
import { getId } from "../../../Components/Functions/word.fun";
import CustomViewButton from "../../../CustomComponent/custom_view_button";
import { titleCaseChange } from "../../../Components/Functions/changeFirstLetterUpperCase";
import { extractDate } from "../../../Components/Functions/date.fun";

const tableHead = ["Sr.", "Rfm Number", "Purpose Use", "Created At", "Generated By","Actions"];
const AllRfmTable = ({ PO = [], currentPage, itemsPerPage }) => {
  const navigate = useNavigate();
  const goToView = (id) => {
    id = getId(id);
    navigate(`/view-req-for-material/${id}`);
  };
  return (
    <div className="table-responsive">
      <table className="table table-vcenter">
        <thead>
          <tr>
            {tableHead?.map((item, index) => {
              return <th key={index}>{item}</th>;
            })}
          </tr>
        </thead>
        <tbody>
          {PO?.map((item, index) => {
            const Index = (currentPage - 1) * itemsPerPage + index + 1;
            return (
              <tr key={item?.rfmNumber}>
                <td>{Index}</td>
                <td>{item?.rfmNumber}</td>
                <td>{titleCaseChange(item?.purposeUse) || "N/A"}</td>
                <td>{extractDate(item?.createdAt) || "N/A"}</td>
                {/* <td>{item?.vendorQuotationOrderDate || "N/A"}</td> */}
                <td>{item?.generatedBy || "N/A"}</td>
                <td>
                  <CustomViewButton
                    onClick={() => goToView(item.rfmNumber)}
                  ></CustomViewButton>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};
export default AllRfmTable;
